export default {
    title: 'Notification center',
    select: {
        allNotifications: 'All notifications'
    },
    leftReview: 'left a review',
    leftComment: 'left a comment',
    user: 'User',
    buyer: 'Buyer',
    store: 'Store',
    product: 'Product',
    yourStore: 'Your Store has been',
    verified: 'verified',
    refundRequest: 'Product refund request',
    inTheAmount: 'in the amount of',
    cardPayment: 'Your credit card billing option request is',
    approved: 'approved.',
    enabled: 'approved.',
    denied: 'denied.',
    is: 'is',
    cardEnable: 'You can enable it',
    here: 'here',
    orderNumber: 'Order number: ',
    hasChangedStatus: 'has changed status of order number',
    storeHasChangedStatus: 'has changed status of order number',
    createOrder: 'Order has been created. Order number: ',
    hasAcceptedInvitation: 'has accepted an invitation to your store',
    becameUnavailable: 'became unavailable. The number of stocks in the inventory dropped to 0',
    deliveredOrder: 'has recently delivered order number',
    remindToReview: "Don't forget to review products.",
    table: {
        header: {
            title: 'Notification'
        },
        answerButton: 'Answer',
        seeButton: 'See'
    },
    modal: {
        successMessage: 'Successfully posted an answer.',
        comment: {
            title: 'Comment',
            buyer : {
                message: 'commented and left a rating for the product:',
                textarea: {
                    title: 'Leave a comment',
                },
                optional: 'optional',
                button: {
                    close: 'Close',
                    answer: 'Answer'
                }
            },
            seller: {
                message: {
                    text1: 'Seller',
                    text2: 'commented and left a rating for the product:',
                    text3: 'responded on your comment for the product:'
                },
                textarea: {
                    title: 'Leave a comment',
                },
                optional: 'optional',
                button: {
                    close: 'Close',
                    see: 'See',
                    answer: 'Answer'
                }
            }

        },

    }
}
